import { render, staticRenderFns } from "./AuthorPage.vue?vue&type=template&id=f6976af4&scoped=true&"
import script from "./AuthorPage.vue?vue&type=script&lang=ts&"
export * from "./AuthorPage.vue?vue&type=script&lang=ts&"
import style0 from "./AuthorPage.vue?vue&type=style&index=0&id=f6976af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6976af4",
  null
  
)

export default component.exports